<div class="page-container topspaces vh-70">
  <piqet-angular-breadcrumbs
    [activatedPath]="activatedRoute"
    [projectName]="projectName"
  ></piqet-angular-breadcrumbs>
  <div class="page-content responsive-height" id="post6">
    <div class="container-fluid h-100">
      <div class="mainDiv d-flex margin-top-10">
        <div class="sideMenu">
          <piqet-angular-project-details-sidebar
            (projectNameEvent)="handleData($event)"
            [sidebarTour]="[sidebarTour]"
          ></piqet-angular-project-details-sidebar>
        </div>
        <div [ngClass]="{ 'disabled-project': !isEdit }" class="contentDiv" id="scrollableDiv">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
